function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43.5 6h-39A4.56 4.56 0 000 10.63v27.74A4.56 4.56 0 004.5 43h39c2.49 0 4.5-2.07 4.5-4.63V10.64A4.56 4.56 0 0043.5 6zm0 4.63v3.93c-2.1 1.76-5.45 4.5-12.62 10.26l-.91.77c-1.7 1.45-4.16 3.56-5.97 3.53-1.81.03-4.28-2.08-5.97-3.53l-.91-.77A938.7 938.7 0 014.5 14.56v-3.94h39zm-39 9.86v17.89h39V20.48c-2.15 1.76-5.2 4.23-9.84 7.97l-1 .83c-2.14 1.84-5.23 4.48-8.66 4.46-3.44.02-6.57-2.66-8.68-4.47l-.98-.83A1609 1609 0 014.5 20.5z"
})));